import { useCallback } from 'react';
import { CustomsCodeItem } from '@texas/api/endpoints/metadata/customsCodesApi';

export function useCustomsCodes({
  customsCodes,
}: {
  customsCodes: CustomsCodeItem[] | null;
}) {
  const customsCodesInBranch = useCallback(
    (branchId: number) =>
      customsCodes?.filter((c) => c.branchId === branchId && !c.archived) ?? [],
    [customsCodes],
  );

  const findCustomsCode = useCallback(
    (id: number) => customsCodes?.find((c) => c.id === id),
    [customsCodes],
  );

  return { customsCodesInBranch, findCustomsCode };
}
